import {createBrowserRouter, createRoutesFromElements, defer, Route} from "react-router-dom";
import AuthLayout from "./layout/AuthLayout";
import LoginPage from "./pages/auth/LoginPage";
import ProtectedLayout from "./layout/ProtectedLayout";
import DashboardPage from "./pages/home/DashboardPage";
import "../src/styles/Style.sass"
import KasaGunlukRaporPage from "./pages/report/KasaGunlukRaporPage";
import KasaTarihBazliRaporPage from "./pages/report/KasaTarihBazliRaporPage";
import KasaAylikDokumRaporPage from "./pages/report/KasaAylikDokumRaporPage";
import RestaurantHaftalikOzetRapor from "./pages/restaurant/RestaurantHaftalikOzetRapor";
import FotoKapanRaporPage from "./pages/fotokapan/FotoKapanRaporPage";
import FotoKapanHaftalikRaporPage from "./pages/fotokapan/FotoKapanHaftalikRaporPage";
import FotoKapanTarihAralikliRaporPage from "./pages/fotokapan/FotoKapanTarihAralikliRaporPage";
import RestaurantTarihAralikliOzetRapor from "./pages/restaurant/RestaurantTarihAralikliOzetRapor";
import RestaurantYillikOzetRapor from "./pages/restaurant/RestaurantYillikOzetRapor";

const getUserData = () =>
    new Promise((resolve) =>
        setTimeout(() => {
            const user = window.localStorage.getItem("user");
            resolve(user);
        }, 1000)
    );

export const router = createBrowserRouter(
    createRoutesFromElements(
        <Route
            element={<AuthLayout />}
            loader={() => defer({ userPromise: getUserData() })}
        >
            <Route>
                <Route path={"/login"} element={<LoginPage></LoginPage>}></Route>
            </Route>

            <Route path="/" element={<ProtectedLayout />}>
                <Route path="/" element={<DashboardPage />} />
            </Route>

            <Route path="/dashboard" element={<ProtectedLayout />}>

                <Route path="/dashboard" element={<DashboardPage />} />
            </Route>


            <Route path="/report" element={<ProtectedLayout />}>
                <Route path="/report/kasa-gunluk-rapor" element={<KasaGunlukRaporPage />} />
                <Route path="/report/kasa-tarih-rapor" element={<KasaTarihBazliRaporPage />} />
                <Route path="/report/kasa-aylik-dokum" element={<KasaAylikDokumRaporPage />} />
            </Route>


            <Route path="/restaurant" element={<ProtectedLayout />}>
                <Route path="/restaurant/haftalik-ozet-rapor" element={<RestaurantHaftalikOzetRapor />} />
                <Route path="/restaurant/tarih-aralikli-ozet-rapor" element={<RestaurantTarihAralikliOzetRapor />} />
                <Route path="/restaurant/yillik-ozet-rapor" element={<RestaurantYillikOzetRapor />} />
            </Route>

            <Route path="/fotokapan" element={<ProtectedLayout />}>
                <Route path="/fotokapan/haftalik-rapor" element={<FotoKapanHaftalikRaporPage />} />
                <Route path="/fotokapan/yillik-rapor" element={<FotoKapanRaporPage />} />
                <Route path="/fotokapan/tarih-aralikli-rapor" element={<FotoKapanTarihAralikliRaporPage />} />
            </Route>
        </Route>
    )
)
